import DateTimeRangeFilter, {
  DateFilterObject,
} from '../../../../common/filter/DateTimeRangeFilter'
import { IFiltersProps } from './Filters.types'

export const Filters = (props: IFiltersProps) => {
  const { filters, hasExport } = props
  const { onApplyFilters, onFiltersChange, onResetFilter, onExport } = props

  const updateTime = (filterData: DateFilterObject) => {
    onFiltersChange({
      ...filters,
      dateStart: filterData.dateStart,
      dateEnd: filterData.dateEnd,
    })
  }

  return (
    <>
      <div className='d-flex flex-column flex-md-row flex-lg-column flex-xxl-row gap-4 align-items-center'>
        <DateTimeRangeFilter
          filter={filters}
          updateTime={updateTime}
          hideRanges
          className='w-100'
        />
        <div className='d-flex flex-column flex-sm-row flex-md-column flex-lg-row w-100 gap-4 align-items-md-center'>
          <button className='btn btn-success' onClick={onApplyFilters}>
            Фильтровать
          </button>

          <button className='btn btn-primary' onClick={onResetFilter}>
            Сбросить фильтр
          </button>

          {hasExport && (
            <button className='btn btn-primary' onClick={() => onExport?.()}>
              Экспортировать
            </button>
          )}
        </div>
      </div>
    </>
  )
}
